'use strict';

var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
'use strict';

var BlimpExtTopten = new Class({
	Extends: BlimpExt,

	initialize: function initialize(link, options) {
		this.setOptions(options);
		this._link = link || document.getElement('.w_blimp_topten');
		this.opts = this.options;
		this.draggable = this.options.draggable;
		if (this._link) {
			this.state = false;
			this.build();
		}
	},

	post_process_build: function post_process_build() {
		new Cont(this._element, '.pagination');

		this.parent();
	}

});
'use strict';

/*
---
name: Cont

authors:
- David Chan CK (http://www.reol.com)
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var Cont = new Class({

	initialize: function initialize(element, links) {
		this._element = element;
		this.links_cls = links;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._content = this._element.getElement('.w_cont');

		this.assign_links();
	},

	assign_links: function assign_links() {
		this._links = this._element.getElements(this.links_cls);

		this._links.each(function (e) {
			e.addEvent('click:relay(a)', function (event, clicked) {
				event.stop();
				var href = clicked.getProperty('data-rpc') || clicked.getProperty('href');

				this.remote = new Remote({
					rpc: href,
					onSuccess: this.replace_content.bind(this)
				});
			}.bind(this));
		}.bind(this));
	},

	replace_content: function replace_content() {
		var cont = this.remote.get_data();

		this._content.set('html', cont.content);
		this.assign_links();
	}

});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

var Multisortable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_multisortable',
		divtable_zebra_order: null
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;
		var self = this;
		var _selects = this._element.getElements('select');
		var _divtable = this._element.getElement('.w_divtable');
		var first_load = true;

		this._trs = _divtable ? _divtable.getElements('.tr') : [];
		this._listing_trs = [];
		this._bld_trs = [];

		this._trs.each(function (_tr) {
			if (_tr.hasClass('_bld')) {
				self._bld_trs.push(_tr);
			} else if (!_tr.hasClass('adbld')) {
				self._listing_trs.push(_tr);
			}
		});

		_selects.each(function (_el) {
			_el.addEvent('change', function () {
				var url = _el.getElement(':selected').getAttribute('data-href');
				if (url && url != '') {
					window.location = url;
				}
			});
		});

		var divtable = Multisortable.divtable = new Divtable(_divtable, { 'zebra_order': opts.divtable_zebra_order });
		var _st = this._element.getElement('.sort_tools');

		if (_st && _st.isDisplayed()) {
			var _toggle = _st.getElement('.w_toggle');
			var self = this;
			if (_toggle && _toggle.isDisplayed()) {
				new Toggle(_toggle, {
					divider: false,
					onToggle: function onToggle() {
						if (!_divtable || first_load) {
							return;
						}
						_divtable.toggleClass('_list_view');

						if (_divtable.hasClass('_list_view')) {
							_divtable.removeClass('_gallery_view');
							Cookie.write('crListingView', 'list');
						} else {
							_divtable.addClass('_gallery_view');
							Cookie.write('crListingView', 'gallery');
							if (!self.indicators_installed) {
								self.set_indicators(_divtable);
							}
						}
					}
				});

				var _gallery = _toggle.getElement('li.gallery');
				var _list = _toggle.getElement('li.list');

				if (Cookie.read('crListingView') === 'list') {
					if (_list) {
						_list.fireEvent('click', [_list]);
					}

					if (_divtable) {
						_divtable.addClass('_list_view');
						_divtable.removeClass('_gallery_view');
					}
				} else {
					if (_gallery) {
						_gallery.fireEvent('click', [_gallery]);
					}

					if (_divtable) {
						_divtable.removeClass('_list_view');
						_divtable.addClass('_gallery_view');
					}
				}
			} else {
				if (_divtable) {
					_divtable.removeClass('_list_view');
					_divtable.addClass('_gallery_view');
				}
			}
		} else {
			if (_divtable) {
				_divtable.removeClass('_list_view');
				_divtable.addClass('_gallery_view');
			}
		}

		var _sm_container = this._element.getElement('.lazy_pager');
		if (_sm_container) {
			var max_pages = _sm_container.getElement('ul').getAttribute('data-max-pages') || 1;
			var data_rpc = '';
			var _a = _sm_container.getElement('li.next a');

			if (_a) {
				data_rpc = _a.get('data-rpc') || _a.getProperty('href');
			}

			if (data_rpc != '') {
				data_rpc = data_rpc.replace(/&page=[0-9]/, '');
				var _show_more = new Element('.show_more', { 'text': 'Show More' });
				_show_more.setProperties({ 'data-max-pages': max_pages, 'data-rpc': data_rpc + '&lazy=1&page=' });
				_show_more.inject(_sm_container, 'before');
				_sm_container.dispose();

				this.lazyloader = new RpcLazyLoader(_divtable.getElement('.tbody'), _show_more, {
					onAddNewContent: function onAddNewContent(e) {
						divtable.add_new_rows(e);
						if (!document.getElement('.show_more') && _divtable.getElements('.tr').length < 500) {
							divtable.reinitialize();
						}

						e.each(function (_el) {
							var _pricehistory = _el.getElement('.w_blimp_pricehistory');
							if (_pricehistory) {
								new BlimpExtPricehistory(_pricehistory, {
									draggable: true,
									show_veil: true
								});
							}
						});
					}
				});
			}
		}

		if (_divtable) {
			first_load = false;
			if (_divtable.hasClass('_gallery_view')) {
				this.set_indicators(_divtable);
			}
		}
	},

	set_indicators: function set_indicators(_divtable) {
		var opts = this.options;
		var self = this;
		var _indicators = this._element.getElements('.indicator');
		var _sorted_indicators = {};

		_indicators.each(function (_el) {
			var index = _el.getAttribute('data-bedroom-id') || _el.get('class');

			if (!_sorted_indicators[index]) {
				_sorted_indicators[index] = [];
			}
			_sorted_indicators[index].push(_el);
		});

		Object.each(_sorted_indicators, function (_inds, i) {
			var maxvalue = 0;
			var data_prop = _inds[0].getAttribute('data-property-indicator');

			if (data_prop) {
				maxvalue = _divtable.getElement('.tbody').getAttribute(data_prop) || 0;
			}

			if (opts.set_indicator_by_beds) {
				var _apartments_stats = self._element.getElement('#apartments_stats');

				if (_apartments_stats) {
					var data = JSONMOO.decode(_apartments_stats.get('html'), false);
					maxvalue = data.apartments[i] || 0;
				}
			}

			new Rater(_inds, {
				'property': 'data-value',
				'size': 'absolute',
				'animate': true,
				'type': 'horisontal',
				'duration': 1500,
				'equal_speed': true,
				'max_data': maxvalue.toInt(),
				'calculate_even_one_element': true
			});
		});
		Core.add_bars_support(this._element);
		this.indicators_installed = true;
	}
});

Multisortable.divtable;
Multisortable.lazyloader;
'use strict';

var Card = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card',
		is_autorun: true,
		is_preloaded: true,
		first_autorun_duration: 5000,
		autorun_duration: 5500,
		transition_duration: 200
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
			this.adaFix();
		}
	},

	adaFix: function adaFix() {
		this._element.setAttribute('role', 'region');
		this._element.setAttribute('aria-label', 'carousel');
	},

	build: function build() {
		var _this2 = this;

		var opts = this.options,
		    fcls = '.' + opts.cls,
		    _this = document.id(this);

		this.is_first = true;
		this.pagination = null;

		this._btnprevious = _this.getElement(fcls + '_btnprevious') || new Element('div');
		this._btnnext = _this.getElement(fcls + '_btnnext') || new Element('div');
		this._stage = _this.getElement(fcls + '_stage');
		this._pagination = _this.getElement(fcls + '_pagination') || new Element('div', { 'class': opts.cls + '_pagination' }).inject(this._stage, 'after');
		this._items = _this.getElements(fcls + '_item');

		this.stage = new Card.Stage(this._stage, this._items, this);

		if (this._items.length == 1) {
			this.set_image(0);

			this._btnprevious.dispose();
			this._btnnext.dispose();
		} else {
			this.pagination = new Card.Pagination(this._pagination, this);

			this._btnprevious.addEvent('click', function () {
				this.is_clicked = true;
				this.clear_periodical();
				this.set_previous_image();
			}.bind(this));

			this._btnnext.addEvent('click', function () {
				this.is_clicked = true;
				this.clear_periodical();
				this.set_next_image();
			}.bind(this));

			this.set_image(0);

			this.periodical = null;

			if (opts.is_autorun) {
				// will have to inject a play / pause button if it is auto play
				var playOrPause = new Element('button', {
					html: 'Pause',
					'class': 'card-play-pause no-style'
				});

				// should be place after w_card_btnprevious
				var previousBtn = this._element.querySelector('.w_card_btnprevious');
				if (!previousBtn) return;
				playOrPause.inject(previousBtn, 'after');
				playOrPause.addEventListener('click', function () {
					if (_this2.periodical) _this2.clear_periodical();else _this2.autoPlay();
				});
				this.playOrPause = playOrPause;
				this.autoPlay();
			}
		}
	},

	autoPlay: function autoPlay() {
		var opts = this.options;
		this.set_direction('next');
		this.playOrPause.innerHTML = 'Pause';
		(function () {
			this.set_next_image();

			this.clear_periodical();
			this.periodical = this.set_next_image.periodical(this.options.autorun_duration, this);
		}).bind(this).delay(opts.first_autorun_duration);
	},

	clear_periodical: function clear_periodical() {
		if (this.options.is_autorun && this.periodical) {
			clearInterval(this.periodical);
			this.periodical = null;
			this.playOrPause.innerHTML = 'Play';
		}

		return this;
	},

	get_direction: function get_direction() {
		return this.direction;
	},

	set_direction: function set_direction(direction) {
		this.direction = direction;
		return this;
	},

	set_image: function set_image(index) {
		if (!this.is_animating) {
			this.stage.set_image_by_index(index);

			if (this.pagination) {
				this.pagination.set_current_page_index(index);
			}
		}
	},

	set_next_image: function set_next_image() {
		this.set_direction('next');
		this.set_image(this.pagination.retrieve_next());
	},

	set_previous_image: function set_previous_image() {
		this.set_direction('previous');
		this.set_image(this.pagination.retrieve_previous());
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Pagination = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_pagination'
	},

	initialize: function initialize(_element, card, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.card = card;
		this.build();
	},

	build: function build() {
		var _this = this._element;

		this.items = [];
		this.current_page_index = 0;

		this.card._items.length.times(function (i) {
			var item = new Element('a', {
				'href': '#',
				'html': '',
				events: {
					click: function (e) {
						if (e && e.stop) e.stop();

						if (i == this.get_current_page_index()) return;

						var direction = this.get_current_page_index() < i ? 'next' : 'previous';

						this.card.is_clicked = true;
						this.card.clear_periodical().set_direction(direction).set_image(i);
					}.bind(this)
				}
			}).inject(_this);

			this.items.push(item);
		}.bind(this));
	},

	get_current_page_index: function get_current_page_index() {
		return this.current_page_index;
	},

	retrieve_next: function retrieve_next() {
		var count = this.items.length;

		if (this.current_page_index == count - 1) {
			return 0;
		}

		return this.current_page_index + 1;
	},

	retrieve_previous: function retrieve_previous() {
		var count = this.items.length;

		if (this.current_page_index == 0) {
			return count - 1;
		}

		return this.current_page_index - 1;
	},

	set_current_page_index: function set_current_page_index(index) {
		this.items[this.current_page_index].removeClass('selected');
		this.current_page_index = index;
		this.items[index].addClass('selected');
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Stage = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_stage'
	},

	initialize: function initialize(_element, _items, card, options) {
		if (!_element) return;

		this.setOptions(options);

		this._element = _element;
		this._items = _items;
		this.card = card;
		this.build();
	},

	build: function build() {
		var opts = this.options,
		    fcls = '.' + opts.cls,
		    _this = document.id(this);

		this.active_item = null;
		this.items = [];
		this.times_accessed = 0;

		this._canvas = _this.getElement(fcls + '_canvas');

		this._items.each(function (_item, i) {
			var item_options = {};

			if (i == 0) {
				item_options = {
					preloads: false
				};
			}

			this.items.push(new Card.Item(_item, this, this.card, item_options));
		}.bind(this));

		if (this.card.options.is_preloaded) {
			this.preload();
		}
	},

	preload: function preload() {
		var images = [];

		this.items.each(function (itm) {
			images.push(itm.get_src());
		}.bind(this));

		Asset.images(images, {
			onProgress: function (c, i) {
				this.items[i].is_loaded = true;
				this.items[i].set_image();
			}.bind(this),

			onComplete: function () {
				this.fireEvent('on_preload');
			}.bind(this)
		});
	},

	get_container: function get_container() {
		return this._canvas;
	},

	set_image: function set_image(item) {
		if (this.active_item) {
			this.active_item.close();
		}

		this.active_item = item;
		item.open();
		item.set_image();
		this.times_accessed++;
	},

	set_image_by_index: function set_image_by_index(index) {
		this.set_image(this.items[index]);
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Item = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_item',
		preloads: true
	},

	initialize: function initialize(_element, stage, card, options) {
		//console.log(_element); return;
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.stage = stage;
		this.card = card;
		this.build();
	},

	build: function build() {

		var _this = document.id(this);

		this.has_image = false;

		var _img = _this.getElement('img') || _this;

		this.src = _img.getAttribute('data-image');
		this.url = _this.getAttribute('data-url') || false;
		this.targeted = _this.getAttribute('data-target') || false;

		if (this.url) {
			this.enable_card_click();
		}

		this.is_loaded = false;

		this.width = _this.getSize().x;

		var dur = this.card.options.transition_duration || 0;
		this._element.set('tween', { link: 'cancel', duration: dur });
	},

	enable_card_click: function enable_card_click() {
		this._element.setStyle('cursor', 'pointer');
		this._element.addEvent('click', function () {
			this.go_to_url();
		}.bind(this));
	},

	go_to_url: function go_to_url() {
		if (this.targeted) {
			window.open(this.url, this.targeted);
			return;
		}

		location.href = this.url;
	},

	close: function close() {
		var _this = this._element;

		_this.removeClass('active');

		var __hide = function __hide() {
			_this.setStyle('left', '150%');
			_this.get('tween').removeEvent('complete', __hide);
		};

		_this.set('tween', {
			onComplete: __hide
		});

		_this.tween('opacity', 0);

		this.fireEvent('close');
	},

	preload: function preload() {
		if (this.options.preloads) {
			Asset.image(this.src);
		}
	},

	load_image: function load_image() {
		(function () {
			Asset.image(this.src, {
				onLoad: function () {
					this.is_loaded = true;
					this.set_image();
				}.bind(this)
			});
		}).delay(300, this);
	},

	open: function open() {
		var _this = this._element;

		_this.addClass('active');

		_this.setStyles({
			'opacity': 0.1,
			'left': 0
		});

		_this.tween('opacity', 1);

		this.fireEvent('open');
	},

	get_src: function get_src() {
		return this.src;
	},

	set_image: function set_image() {
		if (!this.is_loaded && !this.card.options.is_preloaded) {
			this.load_image();
		} else {
			if (!this.has_image) {
				this.has_image = true;
				var sanitized = this.src.trim();
				// document.id(this).setStyle('background-image', 'url('+sanitized+')');
				var _this = document.id(this);
				var _img = _this.getElement('img') || _this;

				_img.setProperty('src', sanitized);
			}
		}
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

angular.module(NgAppName).directive('crAvailableApts', ['PubSub', '$http', '$timeout', '$sce', '$compile', 'StateService', 'gVariables', 'crResourcesService', 'ImageService', function (PubSub, $http, $timeout, $sce, $compile, StateService, gVariables, crResourcesService, ImageService) {
    return {
        templateUrl: 'crAvailableApts/crAvailableApts.html',
        restrict: 'E', // Use 'E' to restrict the directive to element names
        scope: {
            startingDate: '@',
            showLastPctChange: '@?',
            isSimilarApts: '@',
            testMode: '@',
            rpcBuildingApts: '@',
            rpcBuildingAptsForSale: '@',
            currentListingId: '@',
            buildingInfo: '@',
            user: '@',
            companyPhone: '@',
            contactRpc: '@',
            isBuildingPopup: '@',
            openhouseGtag: '@',
            rpcSaveToProfile: '@',
            isArticle: '@',
            rpcListingPopup: '@'
        },
        link: function link(scope, element, attrs) {
            scope.loadingData = false;
            scope.listings = [];
            scope.rows = [];
            if (!scope.showLastPctChange) scope.showLastPctChange = 0;
            if (!scope.isBuildingPopup) scope.isBuildingPopup = 1;
            if (!scope.rpcListingPopup) scope.showPopupButton = false;

            scope.loadData = function () {
                scope.loadingData = true;

                if (scope.rpcBuildingApts && scope.rpcBuildingApts !== '') {
                    $http({
                        method: 'GET',
                        url: scope.rpcBuildingApts,
                        headers: { 'X-Requested-With': 'XMLHttpRequest' }
                    }).then(function successCallback(response) {
                        scope.listings = scope.rows = response.data.items;

                        var availableAptsTabs = document.querySelectorAll('.lst_links .available_apts');
                        if (availableAptsTabs.length && scope.listings && scope.listings.length) {
                            availableAptsTabs.forEach(function (availableAptsTab) {
                                availableAptsTab.style.display = 'inline-block';
                            });
                        }

                        if (scope.listings && scope.listings.length) {
                            var parentElement = element[0].closest('.similar-apts.listing-overview');
                            if (parentElement) {
                                parentElement.style.display = 'block';
                            }
                        }

                        if (scope.listings && scope.listings.length && scope.isArticle == '1') document.querySelector('#mia_main .featured-listings-section').style.display = 'block';

                        if (scope.rpcListingPopup && scope.listings && scope.listings.length >= 6) scope.showPopupButton = true;
                        if (scope.testMode) scope.showPopupButton = false;
                        if (!scope.listings || !scope.listings.length) {
                            // No available apartments, remove the parent element with .similar-bldg-container class
                            var similarBldgContainer = element[0].closest('.similar-bldg-container');
                            if (similarBldgContainer) {
                                var similarBldgContainerHeader = document.querySelector('.persist_nav_container ._similar_buildings');
                                if (similarBldgContainerHeader) {
                                    similarBldgContainerHeader.parentElement.remove();
                                }
                                similarBldgContainer.remove();
                            }
                        }

                        var notFoundImageCnt = 0;
                        if (!scope.listings) return;

                        var _loop = function _loop(i) {
                            if (!scope.listings[i].thumbor_images || !!scope.listings[i].thumbor_images && !scope.listings[i].thumbor_images.length) {
                                var dsIdIndex = notFoundImageCnt % 8;
                                var dsId = window.NotFoundImageDsIds[dsIdIndex];
                                var notFoundImageUrl = window.thumbor_server_cdn;
                                notFoundImageUrl += '/assets/fit-in/525x322/' + dsId;
                                scope.listings[i].notFoundImageUrl = notFoundImageUrl;
                                notFoundImageCnt++;
                            } else {
                                scope.listings[i].listingSlides = [];
                                scope.listings[i].thumbor_images.forEach(function (image) {
                                    var processedImage = ImageService.getSmartImage(attrs.width, attrs.height, image, attrs.mode, attrs.format);
                                    scope.listings[i].listingSlides.push(processedImage);
                                });
                            }
                        };

                        for (var i = 0; i < scope.listings.length; i++) {
                            _loop(i);
                        }
                    }, function errorCallback(response) {
                        console.log('error', response);
                    }).finally(function () {
                        scope.loadingData = false;
                    });
                }
            };

            // Call loadData initially
            scope.loadData();

            scope.showApts = function ($event) {
                var similarListingsTabs = document.querySelectorAll('.lst_links .available_apts');
                if (similarListingsTabs.length) {
                    similarListingsTabs.forEach(function (similarListingsTab) {
                        similarListingsTab.click();
                    });
                    return;
                }
                $event && $event.preventDefault();
                var buttonElement = angular.element($event.currentTarget);
                if (buttonElement.attr('data-rpc')) {
                    buttonElement.blimp = new BlimpExtV2(null, {
                        cache: false,
                        draggable: true,
                        show_veil: true,
                        display: 'apts',
                        fullscreen: true,
                        rpc_url: buttonElement.attr('data-rpc'),
                        onFetch: function onFetch() {
                            _gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
                        },
                        onPostRpc: function onPostRpc() {
                            this.add_extra(true);

                            Core.compile_html(this._element);
                        }
                    });
                    buttonElement.blimp.handle_link_click();
                }
            };
        }
    };
}]);
'use strict';

angular.module(NgAppName).directive('crGalleryViewListingV2', ['$timeout', '$compile', 'crResourcesService', 'PubSub', 'gVariables', function ($timeout, $compile, crResourcesService, PubSub, gVariables) {
	return {
		templateUrl: "crGalleryViewListingV2/crGalleryViewListingV2.html",
		restrict: 'A',
		scope: true,
		controller: ['$scope', '$filter', function ($scope, $filter) {
			$scope.pageType = window.pageType;
			$scope.$filter = $filter;
		}],
		link: function link(scope, element, attrs) {
			scope.removable = attrs.removable;
			scope.unitOnly = attrs.unitOnly;
			scope.hideMap = attrs.hideMap == 'true' ? true : false;
			scope.hideVideo = attrs.hideVideo == 'true' ? true : false;
			scope.style = attrs.style;
			scope.isGuest = G;
			scope.isBroker = B;
			scope.pageId = gVariables.pageId;
			scope.isListingStyle = scope.style === 'listing';
			scope.deleteInProgress = false;
			scope.imageHeight = attrs.imageHeight || 322;
			scope.imageWidth = attrs.imageWidth || 525;
			scope.companyPhone = attrs.companyPhone;
			scope.source = attrs.source;
			scope.contactRpc = attrs.contactRpc;
			scope.openhouseGtag = attrs.openhouseGtag;
			scope.startingDate = attrs.startingDate;
			scope.showLastPctChange = attrs.showLastPctChange == '1' ? true : false;

			// below is for popups
			scope.isBuildingPopup = attrs.isBuildingPopup == '1' ? true : false;
			scope.showBuildingApts = attrs.showBuildingApts == '1' ? '1' : false;
			scope.currentListingId = attrs.currentListingId ? attrs.currentListingId : false;
			scope.rpcBuildingApts = attrs.rpcBuildingApts ? attrs.rpcBuildingApts : false;
			try {
				scope.buildingInfo = attrs.buildingInfo ? JSON.parse(attrs.buildingInfo) : false;
			} catch (error) {
				scope.buildingInfo = false; // Fallback value
			}
			scope.buildingAptsList = null;

			var willListAnimate = true;

			scope.fullscreenPopup = true;
			scope.clickCounter = 0;

			scope.user = JSON.parse(attrs.user);

			scope.isFloorplanView = Core.get_session_data('isFloorplanView') ? true : false;

			scope.resourcesPath = Res_i;

			scope.tomorrow = '';
			var today = new Date();
			var tomorrowDate = new Date(today);
			tomorrowDate.setDate(tomorrowDate.getDate() + 1);

			scope.tomorrow = tomorrowDate.toISOString().split('T')[0];

			var ctrl = this;

			scope.openTourPopup = function (name) {
				PubSub.publish('cr-popup-open-' + name);
			};

			scope.openPopup = function (event, listing, type) {

				if (event.target.closest('.contact-v2-open') || event.target.closest('.gallery_link_open')) {
					return;
				}

				event.preventDefault();
				event.stopPropagation();
				var isBottomInfoClick = !event.target.closest('.book-a-tour') && !event.target.closest('.links-icons');
				if (event.target.closest('.bottom_info')) {
					if (!isBottomInfoClick) {
						// If not a direct click on bottom_info, stop further processing
						return;
					}
				}

				var sc = scope;
				if (!listing.blimp) {
					var galleryLink = event.target.closest('.gallery_link');
					if (!galleryLink) galleryLink = event.target.closest('.gallery_link_slider');
					if (!galleryLink) galleryLink = event.target.closest('.bottom_info');
					var others_behind = true;
					if (scope.isBuildingPopup && scope.currentListingId) others_behind = false;
					listing.blimp = new BlimpExtV2(galleryLink, {
						cache: true,
						draggable: true,
						show_veil: true,
						fullscreen: true,
						display: type,
						put_others_behind: others_behind,
						onFetch: function onFetch() {
							if (listing.markerLabel) {
								listing.markerLabel.marker.clicked = true;
							}

							_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
						},
						onPostRpc: function onPostRpc() {
							this.add_extra(true);
							Core.compile_html(this._element);
						},
						onShow: function onShow() {
							sc.increaseCounter();
						}
					});
					listing.blimp.handle_link_click();
				} else {
					listing.blimp.handle_link_click();
					listing.blimp.show_widget(type);
					if (type == 'gallery' && listing.blimp && listing.blimp.pagePhotogallery && listing.blimp.pagePhotogallery.pg && listing.blimp.pagePhotogallery.pg.current_index) {
						listing.blimp.pagePhotogallery.pg.scrollMainToPosition(listing.blimp.pagePhotogallery.pg.current_index);
					}
				}
			};

			scope.openOffMarketPopup = function (popupName) {
				PubSub.publish('cr-popup-open-' + popupName);
			};

			scope.displayListingAddressVow = function (listing) {
				return listing.display_name;
			};

			scope.displayListingAddress = function (listing) {
				var address = '';
				if (scope.unitOnly) {
					address = listing.unit ? listing.unit.toLowerCase() != 'th' ? 'Apt. ' + scope.$filter('removeUnitParentheses')(listing.unit) : scope.$filter('removeUnitParentheses')(listing.unit) : '';
				} else {
					address = listing.display_name + (listing.unit ? listing.unit.toLowerCase() != 'th' ? ', Apt. ' + scope.$filter('removeUnitParentheses')(listing.unit) : ', ' + scope.$filter('removeUnitParentheses')(listing.unit) : '');
				}
				return address;
			};

			scope.getOpenhouse = function (listing) {
				if (listing.openHouse) {
					return {
						from: listing.openHouseRaw[0][0],
						to: listing.openHouseRaw[0][1],
						display: listing.openHouse[0]
					};
				}
				return null;
			};

			scope.getContactRpc = function (listing) {
				return scope.contactRpc + '?t=' + listing.token;
			};

			scope.increaseCounter = function () {
				scope.clickCounter++;
			};

			scope.showRegistration = function (listing) {
				if (scope.searchType !== 'searchclosed') {
					if (scope.isGuest && (listing.sale_or_rent == 1 || typeof listing.idx !== 'undefined' && listing.idx == 0)) {
						// need to trigger the registration on the 1st and every 7th clicks and gallery otherwise.
						// BUT NOT FOR GOOGLE AD USERS
						if (listing.is_locked_code != 3) {
							// unregistered Google ad users will have is_locked_code = 3
							var nextCounterValue = scope.clickCounter + 1;
							if (nextCounterValue === 1 || nextCounterValue % 7 === 0) {
								return true;
							}
						}
					}
				}
				return false;
			};

			scope.subscribeToGalleryRegistrationEvent = function () {
				var sc = scope;
				document.addEventListener("gallery-registration-opened", function (e) {
					sc.increaseCounter();
				});
			};

			scope.useAlternativeText = function (listing) {
				if (scope.searchType !== "searchclosed") {
					if (scope.isGuest && typeof listing.idx !== "undefined" && listing.idx == 0) {
						return true;
					}
					if (scope.isGuest && listing.sale_or_rent == 1) {
						return false;
					}
				}
				return true;
			};

			scope.delete = function (event, listing) {
				event.stopPropagation();

				var url = scope.rpcSaveToProfile + '?t=' + listing.token;

				var activeFolio = scope.filterPortfolio.options.filter(function (folio) {
					return folio.active;
				})[0];

				listing.portfolio = listing.portfolio.filter(function (folio) {
					var folioTokens = activeFolio.token.split('-');
					var res = true;
					for (var k = 0; k < folioTokens.length; k++) {
						if (folioTokens[k] === folio) {
							res = false;
							break;
						}
					}
					return res;
				});

				// add folio token to the url
				angular.forEach(listing.portfolioList, function (folio) {
					if (folio.shared) {
						if (folio.token === activeFolio.token) {
							folio.shared = false; // update portfolio list
						} else {
							url += '&p[]=' + folio.token;
						}
					}
				});

				listing.deleteInProgress = true;

				this.request = crResourcesService.post2(url, {});
				this.request.$promise.then(function (data) {
					if (data.status) {
						// update listing
						// scope.listingUpdated(listing);

						// update other component (side search whem removing listing on saved apts)
						listing.saveDeleteStatus = 0;
						PubSub.publish('updateListing-' + listing.listing_id, listing);
					}
				}, function errorCallback(response) {
					// todo: manage error
				}).finally(function () {
					listing.deleteInProgress = false;
				});
			};

			//currentListingId
			scope.loadBuildingApts = function () {
				crResourcesService.get(scope.rpcBuildingApts).$promise.then(function (data) {
					if (data && data.items && data.items.length) {
						scope.buildingAptsList = data.items.filter(function (item) {
							return item.listing_id != scope.currentListingId;
						});
					}
				});
			};
			if (scope.buildingInfo && scope.currentListingId) scope.loadBuildingApts();

			// Function to initialize or update IntersectionObserver on `.lst` elements
			function setupIntersectionObserver() {
				var delay = 0;
				var delayIncrement = 0.05;
				var observer = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting && willListAnimate) {
							entry.target.style.animationDelay = delay + 's';
							entry.target.classList.add('fade-in');
							delay += delayIncrement;
							observer.unobserve(entry.target);
						} else {
							entry.target.classList.add('fade-in');
						}
					});
				}, { threshold: 0.1 });

				document.querySelectorAll('.lst').forEach(function (element) {
					observer.observe(element);
				});
			}

			setupIntersectionObserver();

			var debounceTimer = void 0;
			var debounceDelay = 100; // ms

			var mutationObserver = new MutationObserver(function (mutations) {
				var shouldSetupObserver = false;
				mutations.forEach(function (mutation) {
					if (mutation.addedNodes.length) {
						mutation.addedNodes.forEach(function (node) {
							if (node.nodeType === 1 && (node.matches('.lst') || node.querySelector('.lst'))) {
								shouldSetupObserver = true;
							}
						});
					}
				});

				if (shouldSetupObserver) {
					clearTimeout(debounceTimer);
					debounceTimer = setTimeout(function () {
						setupIntersectionObserver();
					}, debounceDelay);
				}
			});

			mutationObserver.observe(document.querySelector('._gallery_v2'), { childList: true, subtree: false });

			scope.subscribeToGalleryRegistrationEvent();

			scope.toggleFloorplanView = function () {
				scope.isFloorplanView = Core.get_session_data('isFloorplanView') ? true : false;
			};
			PubSub.subscribe('toggleFloorplanView', scope.toggleFloorplanView);
		}
	};
}]);
'use strict';

angular.module(NgAppName).directive('crResultsTableSlider', ['PubSub', 'ImageService', function (PubSub, ImageService) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.listingSlides = [];
            scope.listingFloorplans = [];
            scope.currentIndex = 0; // Current slide index
            scope.currentIndexFP = 0; // Current fp index

            scope.setImages = function () {
                if (scope.images && scope.images.length > 0) {
                    scope.listingSlides = scope.images;
                    scope.currentIndex = 0;
                }
                if (scope.floorplans && scope.floorplans.length > 0) {
                    scope.listingFloorplans = scope.floorplans;
                    scope.currentIndexFP = 0;
                }
            };

            // Move to the next slide
            scope.next = function (e) {
                e.stopPropagation();
                scope.currentIndex = scope.currentIndex < scope.listingSlides.length - 1 ? scope.currentIndex + 1 : 0;
            };

            // Move to the previous slide
            scope.prev = function (e) {
                e.stopPropagation();
                scope.currentIndex = scope.currentIndex > 0 ? scope.currentIndex - 1 : scope.listingSlides.length - 1;
            };

            // Move to the next slide
            scope.nextFP = function (e) {
                e.stopPropagation();
                scope.currentIndexFP = scope.currentIndexFP < scope.listingFloorplans.length - 1 ? scope.currentIndexFP + 1 : 0;
            };

            // Move to the previous slide
            scope.prevFP = function (e) {
                e.stopPropagation();
                scope.currentIndexFP = scope.currentIndexFP > 0 ? scope.currentIndexFP - 1 : scope.listingFloorplans.length - 1;
            };

            scope.setImages();
            // if (scope.isPopup) {
            //     scope.setImages(false);
            // } else {
            //     let isFloorplanView = Core.get_session_data('isFloorplanView') ? true : false;
            //     scope.setImages(isFloorplanView);
            // }

            // scope.toggleFloorplanView = () => {
            //     if (!scope.isPopup) {
            //         let isFloorplanView = Core.get_session_data('isFloorplanView') ? true : false;
            //         scope.setImages(isFloorplanView);
            //     }
            // }
            // PubSub.subscribe('toggleFloorplanView', scope.toggleFloorplanView);

            scope.$watch('$ctrl.images', function (images) {
                if (images) {
                    scope.setImages();
                }
            });
        }
    };
}]);
'use strict';

angular.module(NgAppName).directive('crPricechangeBlimp', [function () {
	return {
		restrict: 'A',
		scope: true,

		link: function link(scope, element, attrs) {
			var page = attrs.page;
			var vscroll = attrs.vscroll;
			var fullscreen = attrs.fullscreen;

			var params = {
				draggable: true,
				show_veil: true
			};

			if (attrs.allowOthers == '1') {
				params.allow_others = true;
			}
			if (attrs.putOthersBehind == '1') {
				params.put_others_behind = true;
			}
			if (page === 'lst') {
				params.page = 'lst';
				params.fullscreen = true;
			}

			if (vscroll === '1') {
				params.vscroll = true;
				params.fullscreen = true;
			}

			if (fullscreen) {
				params.fullscreen = true;
			}

			if (attrs.regTrigger) {
				Core.add_signup_link($(element[0]));
			} else {
				new BlimpExtPricehistory($(element[0]), params);
			}
		}
	};
}]);
'use strict';

angular.module(NgAppName).component('crBuildingSaveAndAlert', {
	templateUrl: 'crBuildingSaveAndAlert/crBuildingSaveAndAlert.html',
	transclude: true,
	bindings: {
		identity: '@',
		membersCenterUrl: '@',
		saveUrl: '@',
		objToSave: '<',
		rpcToggle: '@',
		rpcSaveToProfile: '@',
		rpcDeleteToProfile: '@',
		isGuest: '<',
		rpcBuildingInfo: '@',
		similarBuildingIndex: '<',
		type: '@',
		buttonSaveClass: '@',
		btnText: "@",
		hiddenObjWrapper: '<',
		saveAlertButtonCloseClass: '@',
		withLottie: '<',
		objToSaveId: '@',
		buildingToken: "@",
		objToSaveDeleteStatus: '@'
	},
	controller: ['PubSub', '$window', '$element', '$timeout', '$sce', '$compile', '$scope', 'StateService', 'gVariables', 'crResourcesService', function (PubSub, $window, $element, $timeout, $sce, $compile, $scope, StateService, gVariables, crResourcesService) {
		var _this = this;

		var ctrl = this;

		if (!ctrl.buttonSaveClass) {
			ctrl.buttonSaveClass = 'button-save';
		}
		if (!ctrl.saveAlertButtonCloseClass) {
			ctrl.saveAlertButtonCloseClass = 'button-close';
		}
		this.alert = {
			instant: true,
			daily: false
		};

		if (!!this.similarBuildingIndex && this.similarBuildingIndex == 1) {
			this.alertPopupStyles = {
				right: 'unset'
			};
		} else {
			this.alertPopupStyles = {};
		}

		if (ctrl.withLottie) {
			$scope.heartAnimation = { "nm": "Love 2", "ddd": 0, "h": 34, "w": 34, "meta": { "g": "@lottiefiles/toolkit-js 0.33.2" }, "layers": [{ "ty": 4, "nm": "Stroke Outlines", "sr": 1, "st": 0, "op": 30, "ip": 0, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 0, "k": 100, "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 2, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[-0.001, 13.816], [-0.001, -5.575]] }, "ix": 2 } }, { "ty": "st", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Stroke", "nm": "Stroke 1", "lc": 1, "lj": 1, "ml": 10, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 1, "ix": 5 }, "c": { "a": 0, "k": [1, 0.2431, 0.4549], "ix": 3 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }, { "ty": "tm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Trim", "nm": "Trim Paths 1", "ix": 2, "e": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0], "t": 10 }, { "s": [100], "t": 26 }], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "s": { "a": 0, "k": 0, "ix": 1 }, "m": 1 }], "ind": 1 }, { "ty": 4, "nm": "Stroke Outlines 2", "sr": 1, "st": 0, "op": 10, "ip": 0, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [100], "t": 0 }, { "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [100], "t": 8 }, { "s": [0], "t": 10 }], "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 2, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[-0.001, 13.816], [-0.001, -5.575]] }, "ix": 2 } }, { "ty": "st", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Stroke", "nm": "Stroke 1", "lc": 1, "lj": 1, "ml": 10, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 1, "ix": 5 }, "c": { "a": 0, "k": [1, 0.2431, 0.4549], "ix": 3 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }], "ind": 2 }, { "ty": 4, "nm": "Fill Outlines", "sr": 1, "st": 0, "op": 45, "ip": 26, "hd": false, "ddd": 0, "bm": 0, "hasMask": false, "ao": 0, "ks": { "a": { "a": 0, "k": [17, 17, 0], "ix": 1 }, "s": { "a": 1, "k": [{ "o": { "x": 0.167, "y": 0.167 }, "i": { "x": 0.833, "y": 0.833 }, "s": [0, 0, 100], "t": 26 }, { "s": [100, 100, 100], "t": 30 }], "ix": 6 }, "sk": { "a": 0, "k": 0 }, "p": { "a": 0, "k": [17, 17, 0], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 10 }, "sa": { "a": 0, "k": 0 }, "o": { "a": 0, "k": 100, "ix": 11 } }, "ef": [], "shapes": [{ "ty": "gr", "bm": 0, "hd": false, "mn": "ADBE Vector Group", "nm": "Group 1", "ix": 1, "cix": 2, "np": 3, "it": [{ "ty": "sh", "bm": 0, "hd": false, "mn": "ADBE Vector Shape - Group", "nm": "Path 1", "ix": 1, "d": 1, "ks": { "a": 0, "k": { "c": true, "i": [[-22.808, -15.028], [7.437, -8.242]], "o": [[22.809, -15.028], [-7.437, -8.242]], "v": [[0, 13.816], [0, -5.575]] }, "ix": 2 } }, { "ty": "mm", "bm": 0, "hd": false, "mn": "ADBE Vector Filter - Merge", "nm": "Merge Paths 1", "mm": 4 }, { "ty": "fl", "bm": 0, "hd": false, "mn": "ADBE Vector Graphic - Fill", "nm": "Fill 1", "c": { "a": 0, "k": [1, 0.2431, 0.4549], "ix": 4 }, "r": 1, "o": { "a": 0, "k": 100, "ix": 5 } }, { "ty": "tr", "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "p": { "a": 0, "k": [17, 14.684], "ix": 2 }, "r": { "a": 0, "k": 0, "ix": 6 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "o": { "a": 0, "k": 100, "ix": 7 } }] }], "ind": 3 }], "v": "4.12.0", "fr": 15, "op": 45, "ip": 0, "assets": [] };
		}
		this.animation = null;

		this.building = {};

		this.showAlertPopup = false;
		this.overButton = false;

		this.alreadyClicked = false;

		this.$onInit = function () {
			// check building information
			if (!!_this.rpcBuildingInfo) {
				crResourcesService.get(_this.rpcBuildingInfo).$promise.then(function (data) {
					if (data && data.result) {
						if (data.items && Object.keys(data.items).length > 0) {
							// already saved
							_this.building.daily_email_notification = data.items.daily_email_notification;
							_this.building.instant_email_notification = data.items.instant_email_notification;
							_this.building.uuid = data.items.uuid;
						} else {
							// not saved
						}
					}
				});
			}
		};

		this.$postLink = function () {
			var _this2 = this;

			if (this.hiddenObjWrapper) {
				this.objToSave = this.hiddenObjWrapper;
			} else {
				var hiddenObject = angular.element($element[0].getElementsByClassName('obj-wrapper'));

				if (hiddenObject && hiddenObject.html()) {
					this.objToSave = JSON.parse(hiddenObject.html());
					hiddenObject.remove();
				}
			}

			if (!this.objToSave && !!this.objToSaveId) {
				this.objToSave = { id: this.objToSaveId, saveDeleteStatus: this.objToSaveDeleteStatus };
			}

			if (this.objToSave) {

				$element[0].objToSave = this.objToSave;

				if (this.objToSave.saveDeleteStatus && typeof this.objToSave.saveDeleteStatus === 'string') {
					this.objToSave.saveDeleteStatus = parseInt(this.objToSave.saveDeleteStatus);
				}

				PubSub.subscribe('updateBuilding-' + this.objToSave.id, function (building) {
					if (building) {
						_this2.objToSave.saveDeleteStatus = building.saveDeleteStatus;
						if (building.saveDeleteStatus === 0) {
							_this2.objToSave.showTooltip = building.showTooltip;
						}
					}
				});
				ctrl.initializeLottieAnimation();
			}
		};

		this.initializeLottieAnimation = function () {
			if (ctrl.withLottie) {
				$timeout(function () {
					var lottie_elements = $element[0].getElementsByClassName('lottie-container');
					if (lottie_elements && lottie_elements.length > 0) {
						if (ctrl.animation) {
							ctrl.animation.destroy();
						}
						ctrl.animation = lottie.loadAnimation({
							container: lottie_elements[0],
							renderer: 'svg',
							loop: true,
							autoplay: true,
							animationData: $scope.heartAnimation
						});
					}
				});
			}
		};

		this.saveAlert = function ($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}

			var url = void 0;
			if (_this.objToSave.saveDeleteStatus === -1) {
				url = _this.rpcDeleteToProfile ? _this.rpcDeleteToProfile : _this.objToSave.urls ? _this.objToSave.urls.deleteToProfile : null;
			} else {
				url = _this.rpcSaveToProfile ? _this.rpcSaveToProfile : _this.objToSave.urls ? _this.objToSave.urls.saveToProfile : null;
			}

			crResourcesService.post2(url + "&instantNotification=1", {}).$promise.then(function (data) {
				if (data.status) {
					// Set to unsaved status after unsaving the building
					if (_this.objToSave.saveDeleteStatus === -1) {
						_this.objToSave.saveDeleteStatus = 0;
						_this.objToSave.showTooltip = 0;
						_this.updateBuildingStatus(_this.objToSave);
						ctrl.initializeLottieAnimation();
						return;
					}

					_this.showAlertPopup = true;
					_this.alreadyClicked = true;
					_this.building.daily_email_notification = 0;
					_this.building.instant_email_notification = 1;
					_this.building.uuid = data.id || data.uuid;

					_this.objToSave.saveDeleteStatus = -1; // saved
					_this.updateBuildingStatus(_this.objToSave);
				} else {
					// this.showAlertPopup = true;
					// this.alreadyClicked = true;
					// this.errorType = data.type;
				}
			});
		};

		this.clickToggle = function ($event, frequency) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}

			if (frequency === 'instant') {
				_this.alert.daily = false;
				_this.alert.instant = true;
			} else if (frequency === 'daily') {
				_this.alert.instant = false;
				_this.alert.daily = true;
			}

			_this.frequencyChange();
		};

		this.updateBuildingStatus = function (building) {
			PubSub.publish('updateBuilding-' + _this.objToSave.id, _this.objToSave);
			PubSub.publish('updateBuildingAlerts', _this.objToSave); // update button in the header
		};

		this.frequencyChange = function () {
			// save search
			var paramUrl = '';

			if (_this.alert.instant) {
				paramUrl = '&instantNotification=1&dailyNotification=0';
			} else if (_this.alert.daily) {
				paramUrl = '&instantNotification=0&dailyNotification=1';
			} else {
				paramUrl = '&instantNotification=0&dailyNotification=0';
			}
			var finalUrl = _this.rpcToggle + '?uuid=' + _this.building.uuid + paramUrl;

			crResourcesService.post2(finalUrl, {}).$promise.then(function (data) {
				if (data.result) {
					_this.showSearchBanner = false;
				}
			});
		};

		this.close = function ($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			_this.showAlertPopup = false;
		};

		this.redirectToMmembersCenter = function ($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			$window.location.href = _this.membersCenterUrl;
		};
	}]
});
'use strict';

crApp.directive('crTable', ['$http', '$timeout', function ($http, $timeout) {
	return {
		restrict: 'A',
		scope: true,

		link: function link(scope, el, attrs) {
			var __getContent = function __getContent() {
				scope.loadingResults = true;
				scope.hasResults = false;
				$http({
					method: 'get',
					url: attrs.rpc,
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					data: {}
				}).success(function (data, status, headers, config) {
					scope.displayItems = scope.rows = data.items;
					scope.activeListing = data.active;
					scope.loadingResults = false;

					if (data.items && data.items.length) {
						scope.hasResults = true;

						$timeout(function () {
							var elements = document.querySelectorAll(".pricing_history .sales_data.reg_blimp_a");
							for (var i = 0; i < elements.length; i++) {
								Core.add_signup_link(elements[i]);
							}
						}, 0);
					}
				});
			};

			scope.repeatDone = function () {
				$timeout(function () {
					scope.displayMinimumItems();
				}, 500);
			};

			scope.getImageUrl = function (width, height, listing, mode) {
				var ret = null;
				if (listing.thumbor_images && listing.thumbor_images.length > 0) {
					ret = Core.get_smart_image(width, height, listing.thumbor_images[0], mode);
				} else {
					ret = window.Missing_img_big;
				}

				return ret;
			};

			scope.getSimilarListingImageUrl = function (listing) {
				var ret = null;
				if (listing.thumbor_images && listing.thumbor_images.length > 0) {
					ret = Core.get_smart_image(230, 290, listing.thumbor_images[0], 'smart');
				} else {
					ret = window.Missing_img_similar_listing;
				}

				return ret;
			};

			scope.displayMinimumItems = function () {
				el._container = angular.element(el[0].querySelector('.cmp-listview'));
				el._items = angular.element(el[0].querySelectorAll('.row'));
				el._toggler = angular.element(el[0].querySelector('.w_shrinker_head'));
				el.minItems = attrs.minItems;

				if (el && el.minItems && el.minItems < el._items.length) {
					el.minHeight = scope.getMinHeight(el.minItems, el._items);

					el.shrinker = new Shrinker(el._container[0], {
						min_height: el.minHeight,
						toggler: el._toggler[0],
						onShrink: function onShrink() {
							this._toggler.removeClass('_opened');
							this._toggler.set('html', '<span class="w_shrinker_button button _transparent">Show More</span>');
						},
						onUnshrink: function onUnshrink() {
							this._toggler.addClass('_opened');
							this._toggler.set('html', '<span class="w_shrinker_button button _transparent">Show Less</span>');
						}
					});

					scope.showShrinkerButton = true;
				} else if (el._toggler) {
					el._toggler.remove();
				}
			};

			scope.getMinHeight = function (min_item, _elements) {
				var height = 0;

				if (!_elements) return;

				angular.forEach(_elements, function (_el, i) {
					if (i < min_item) {
						height += _el.getSize().y;
					}
				});

				return height;
			};

			__getContent();
		}
	};
}]);
"use strict";

Page.Top = new Class({
  Extends: Page,
  build: function build() {
    this.parent();
  }
});
//# sourceMappingURL=top.js.map
